// ✅ CONSTANTES DE VALIDACIÓN DE FORMULARIOS
export const FORM_CONSTANTS = {
  MIN_PASSWORD_LENGTH: 6,
  MAX_PASSWORD_LENGTH: 128,
  PHONE_PREFIX: '569',
  PHONE_LENGTH: 11,
  MIN_RUT_LENGTH: 8,
  MAX_RUT_LENGTH: 12,
  MIN_NAME_LENGTH: 2,
  MAX_NAME_LENGTH: 50,
  MIN_HEIGHT: 100, // cm
  MAX_HEIGHT: 250, // cm
  MIN_WEIGHT: 30, // kg
  MAX_WEIGHT: 300, // kg
} as const;

// ✅ CONSTANTES DE UI
export const UI_CONSTANTS = {
  BUTTON_BORDER_RADIUS: '50px',
  DEFAULT_PADDING: '5%',
  DEFAULT_MARGIN: '2%',
  ANIMATION_DURATION: '0.3s',
  SHADOW_ELEVATION: 2,
  Z_INDEX: {
    NAVBAR: 10000,
    MODAL: 1300,
    TOOLTIP: 1500,
    SNACKBAR: 1400,
  },
} as const;

// ✅ CONSTANTES DE NEGOCIO
export const BUSINESS_CONSTANTS = {
  DEFAULT_ACTIVATION_CODE: '',
  MAX_ACTIVATION_ATTEMPTS: 3,
  ACTIVATION_CODE_LENGTH: 6,
} as const;

// ✅ CONSTANTES DE USUARIO
export const USER_CONSTANTS = {
  DEFAULT_MODE: 'active-in',
  SESSION_TIMEOUT: 30 * 60 * 1000, // 30 minutos en ms
  MAX_LOGIN_ATTEMPTS: 5,
  PASSWORD_RESET_EXPIRY: 24 * 60 * 60 * 1000, // 24 horas en ms
} as const;

// ✅ CONSTANTES DE API
export const API_CONSTANTS = {
  TIMEOUT: 30000, // 30 segundos
  RETRY_ATTEMPTS: 3,
  RETRY_DELAY: 1000, // 1 segundo
  BASE_URL: process.env.REACT_APP_API_URL || 'http://localhost:3001',
} as const;

// ✅ CONSTANTES DE VALIDACIÓN DE EDAD
export const AGE_CONSTANTS = {
  MIN_AGE: 18,
  MAX_AGE: 100,
} as const;

// ✅ CONSTANTES DE VALIDACIÓN DE TELÉFONO
export const PHONE_CONSTANTS = {
  CHILE_PREFIX: '569',
  MIN_LENGTH: 9,
  MAX_LENGTH: 11,
  FORMAT_PATTERN: /^569\d{8}$/,
} as const;

// ✅ CONSTANTES DE ERRORES
export const ERROR_MESSAGES = {
  REQUIRED_FIELD: 'Este campo es requerido',
  INVALID_EMAIL: 'Email inválido',
  INVALID_PHONE: 'Teléfono inválido',
  INVALID_RUT: 'RUT inválido',
  PASSWORD_TOO_SHORT: `La contraseña debe tener al menos ${FORM_CONSTANTS.MIN_PASSWORD_LENGTH} caracteres`,
  PASSWORD_TOO_LONG: `La contraseña no puede exceder ${FORM_CONSTANTS.MAX_PASSWORD_LENGTH} caracteres`,
  PASSWORDS_DONT_MATCH: 'Las contraseñas no coinciden',
  INVALID_AGE: `La edad debe estar entre ${AGE_CONSTANTS.MIN_AGE} y ${AGE_CONSTANTS.MAX_AGE} años`,
  NETWORK_ERROR: 'Error de conexión. Por favor, intente nuevamente.',
  UNKNOWN_ERROR: 'Error desconocido. Por favor, contacte soporte.',

  // ✅ MENSAJES ESPECÍFICOS DE REGISTRO
  REGISTRATION: {
    FORM_INCOMPLETE: 'Por favor, complete todos los campos requeridos',
    RUT_ALREADY_REGISTERED: 'El RUT ingresado ya está registrado',
    PHONE_ALREADY_REGISTERED: 'El teléfono ingresado ya está registrado',
    INVALID_ACTIVATION_CODE: 'Código de activación inválido',
    BUSINESS_NOT_FOUND: 'Negocio no encontrado',
    TERMS_NOT_ACCEPTED: 'Debe aceptar los términos y condiciones',
    VALIDATION_FAILED:
      'Por favor, complete todos los campos requeridos correctamente',
    USER_CREATION_FAILED:
      'Error al crear usuario. Por favor, intente nuevamente.',
    UNEXPECTED_ERROR: 'Error inesperado. Por favor, intente nuevamente.',
  },

  // ✅ MENSAJES DE ERROR DE SUBDOMINIO
  SUBDOMAIN: {
    INVALID_SUBDOMAIN: 'Subdominio no configurado',
    ACCESS_DENIED: 'Acceso no autorizado',
    NOT_CONFIGURED:
      'El subdominio {hostname} no está configurado en el sistema',
    CONTACT_ADMIN:
      'Por favor, contacte al administrador del sistema para configurar este subdominio o verificar la configuración.',
    REASONS: {
      NOT_CONFIGURED_YET: 'El subdominio no ha sido configurado aún',
      REMOVED: 'El subdominio ha sido removido del sistema',
      DNS_ERROR: 'Error en la configuración de DNS',
    },
  },

  // ✅ MENSAJES DE VALIDACIÓN ESPECÍFICOS
  VALIDATION: {
    RUT_MIN_LENGTH: `RUT debe tener al menos ${FORM_CONSTANTS.MIN_RUT_LENGTH} caracteres`,
    RUT_MAX_LENGTH: `RUT no puede exceder ${FORM_CONSTANTS.MAX_RUT_LENGTH} caracteres`,
    NAME_MIN_LENGTH: `Nombre debe tener al menos ${FORM_CONSTANTS.MIN_NAME_LENGTH} caracteres`,
    NAME_MAX_LENGTH: `Nombre no puede exceder ${FORM_CONSTANTS.MAX_NAME_LENGTH} caracteres`,
    HEIGHT_MIN: `Altura debe ser al menos ${FORM_CONSTANTS.MIN_HEIGHT} cm`,
    HEIGHT_MAX: `Altura no puede exceder ${FORM_CONSTANTS.MAX_HEIGHT} cm`,
    WEIGHT_MIN: `Peso debe ser al menos ${FORM_CONSTANTS.MIN_WEIGHT} kg`,
    WEIGHT_MAX: `Peso no puede exceder ${FORM_CONSTANTS.MAX_WEIGHT} kg`,
    PHONE_INVALID_FORMAT: 'Formato de teléfono inválido',
    PHONE_WRONG_LENGTH: `Teléfono debe tener ${FORM_CONSTANTS.PHONE_LENGTH} dígitos`,
  },
} as const;

// ✅ CONSTANTES DE SUCCESS
export const SUCCESS_MESSAGES = {
  REGISTRATION_SUCCESS: 'Registro exitoso! Redirigiendo...',
  PROFILE_UPDATED: 'Perfil actualizado correctamente',
  PASSWORD_CHANGED: 'Contraseña cambiada correctamente',
  DATA_SAVED: 'Datos guardados correctamente',
} as const;
